import Marquee from "react-fast-marquee";
import { Flag } from "lucide-react";

const items = [
  "Cataratas do Iguaçu — Brasil",
  "Cataratas Argentinas",
  "Compras no Paraguai",
  "Gastronomia argentina",
  "Tríplice Fronteira",
  "Sprinter para 18 passageiros",
  "+15 anos de experiência",
];

export default function MarqueeRibbon() {
  return (
    <div className="bg-brand-deep py-5 border-y border-white/5" data-testid="editorial-marquee">
      <Marquee speed={28} gradient={false} pauseOnHover>
        {items.map((item) => (
          <span key={item} className="mx-12 inline-flex items-center gap-12 text-white/70 font-display text-sm uppercase tracking-[0.35em]">
            {item}
            <Flag size={14} className="text-accent" />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
